import useSWR from "swr";

import { useAuth } from "../../contexts/AuthContext";
import { BAAService } from "../../services";
import type { BAAStatusResponse } from "../../types/baa";
import { useAPI } from "../useAPI";

const BAA_STATUS_KEY = "/baa/status";

export const useBAAStatusData = (options?: { enablePolling?: boolean }) => {
  const api = useAPI("v2");
  const { firmContext } = useAuth();
  const baaService = new BAAService(api);

  const cacheKey = firmContext?.firmId ? [BAA_STATUS_KEY, firmContext.firmId] : null;

  const { data, error, isLoading, mutate } = useSWR<BAAStatusResponse>(
    cacheKey,
    () => {
      if (!firmContext?.firmId) {
        throw new Error("Firm context is not available");
      }
      return baaService.checkBAAStatus(firmContext.firmId);
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 7 * 24 * 60 * 60 * 1000, // 7 days
      // Poll every 2 seconds if enabled and BAA still needs signature, otherwise stop polling
      refreshInterval: options?.enablePolling
        ? (latestData) => (latestData?.needs_signature ? 2000 : 0)
        : 0,
    }
  );

  return {
    baaStatus: data,
    isLoading,
    isError: error,
    mutate,
  };
};
